import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { convertOnOffProgramPaymentFromDto } from "@modules/programs/gateway/programDto"
import { type StripeOnOffProgramSubscriptionDto } from "@modules/programs/gateway/programOnOffDto"
import { type ProgramPayment, ProgramSubscriptionStatus } from "@modules/programs/types/programTypes"

export class StripeOnOffProgramSubscriptionEntity {
  id: string
  subscriptionId: string
  subscriptionStatus: ProgramSubscriptionStatus
  paidDate: Date | null
  paidPrice: PriceObjectEntity | null
  referencePrice: PriceObjectEntity | null
  payment: ProgramPayment | null

  private constructor(stripeOnOffProgramSubscription: StripeOnOffProgramSubscriptionEntity) {
    this.id = stripeOnOffProgramSubscription.id
    this.subscriptionId = stripeOnOffProgramSubscription.subscriptionId
    this.subscriptionStatus = stripeOnOffProgramSubscription.subscriptionStatus
    this.paidDate = stripeOnOffProgramSubscription.paidDate
    this.paidPrice = stripeOnOffProgramSubscription.paidPrice
    this.referencePrice = stripeOnOffProgramSubscription.referencePrice
    this.payment = stripeOnOffProgramSubscription.payment
  }

  static fromDto(programId: string, dto: StripeOnOffProgramSubscriptionDto): StripeOnOffProgramSubscriptionEntity {
    return new StripeOnOffProgramSubscriptionEntity({
      id: programId,
      subscriptionId: dto.subscriptionId,
      subscriptionStatus: dto.subscriptionStatus,
      paidDate: dto.paidDate ? new Date(dto.paidDate) : null,
      paidPrice: dto.paidPrice ? PriceObjectEntity.fromDto(dto.paidPrice) : null,
      referencePrice: dto.referencePrice ? PriceObjectEntity.fromDto(dto.referencePrice) : null,
      payment: dto.payment ? convertOnOffProgramPaymentFromDto(dto.payment) : null,
    })
  }
}
